import ApplyPreset, { AppliedPresetStatus } from './ApplyPreset';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { Space } from 'antd';
import { StyledDivider, ToolbarWrapper } from './styled';
import MetricControlPanel from '@src/components/metrics-panel-hz/control-panel';
import AutoYAxis from './MetricToolbox/AutoYAxis';
import { useFeature } from '@src/globalStore/featureStore';
import DimensionControls from '@src/components/dimension-panel-hz/header/DimensionControls';
import CommonTools from './Common';
import { panelsAtom } from '@src/atoms/panels';
import ShowHoc from './ShowHoc';
import { isAppModule } from '@src/utils/constants';
import { activeTabAtom as dimensionPanelActiveTabAtom } from '@src/components/dimension-panel-hz/atoms';
import { Tabs as dimensionPanelTabs } from '@src/store/trends/base/reducer';
import PanelResize from '@src/components/metrics-panel-hz/control-panel/PanelResize';
import {
  activeTabAtom as metricPanelActiveTabAtom,
  Tabs as metricPanelTabs,
} from '@src/components/metrics-panel-hz/atoms';
import { FlexFill } from '@src/components/common/Utils/Layout';
import { useTrendsFilterPanelHeight } from '@src/atoms/page-styles';
import GranularityControl from './Common/GranularityControl';
import {
  realTimeModeOnTrendsSelector,
  widgetPanelFeatureSelector,
} from '@src/store/common/selectors';
import AdvancedOptions from './AdvancedOptions';
import More from './More';
import External from './More/External';
import featureNames from '@src/utils/featureToggle/constants';
import { useDrilldownMeta } from '@src/hooks/common/useDrilldownMeta';

function ActionToolbar() {
  const { eventId } = useDrilldownMeta();
  const activeMetricPanelTab = useAtomValue(metricPanelActiveTabAtom);
  const activeDimensionPanelTab = useAtomValue(dimensionPanelActiveTabAtom);
  const { metric: metricPanelVisible, dimension: dimensionPanelVisible } = useAtomValue(panelsAtom);
  const liveMode = useSelector(realTimeModeOnTrendsSelector);
  const widgetPanelEnabled = useSelector(widgetPanelFeatureSelector);
  const isAutoYAxisEnabled = useFeature(featureNames.AUTO_Y_AXIS);

  const showControl = {
    widget:
      activeMetricPanelTab === metricPanelTabs.Widgets &&
      widgetPanelEnabled &&
      metricPanelVisible &&
      !liveMode,
    metric: activeMetricPanelTab === metricPanelTabs.MetricCharts && metricPanelVisible,
    dimension: activeDimensionPanelTab === dimensionPanelTabs.TopTrends && dimensionPanelVisible,
    percentile:
      isAppModule &&
      activeMetricPanelTab === metricPanelTabs.MetricCharts &&
      metricPanelVisible &&
      !eventId,
  };

  const filterPanelHeight = useTrendsFilterPanelHeight();

  return (
    <ApplyPreset>
      <ToolbarWrapper $top={filterPanelHeight}>
        <Space>
          <PanelResize />
        </Space>
        <StyledDivider type="vertical" />
        <ShowHoc condition={showControl.metric}>
          <MetricControlPanel />
          {isAutoYAxisEnabled ? <AutoYAxis /> : null}
          <StyledDivider type="vertical" />
        </ShowHoc>
        <ShowHoc condition={showControl.metric || showControl.widget}>
          <GranularityControl />
          <StyledDivider type="vertical" />
        </ShowHoc>
        <AppliedPresetStatus />
        <FlexFill />
        <ShowHoc condition={showControl.dimension}>
          <AdvancedOptions />
          <DimensionControls />
        </ShowHoc>
        <StyledDivider type="vertical" />
        <CommonTools showControl={showControl} />
        <StyledDivider type="vertical" />
        <External />
        <More />
      </ToolbarWrapper>
    </ApplyPreset>
  );
}

export default ActionToolbar;
